export default __webpack_public_path__ + "static/media/downloads.d2c1fd64.svg";